import React, { useState, useEffect, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import "./NotificationAdd.css";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const NotificationAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode, page } = location.state || {};
  const isViewMode = mode === "view";

  const [userType, setUserType] = useState("all"); // 'all' or 'specific'
  const [heading, setHeading] = useState("");
  const [notification, setNotification] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [userList, setUserList] = useState([]);
  const [permissionList, setPermissionList] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (data) {
      setHeading(data?.title || data?.description || "");
      setNotification(data?.description || "");
      setUserType(data?.is_all_users ? "all" : "specific");
      setSelectedUsers(data?.users || []);
    }
  }, [data]);

  const filteredUsers = (userList || []).filter((user) =>
    user?.name?.toLowerCase().includes((searchUser || "").toLowerCase())
  );

  const handleUserSelect = (user) => {
    if (isViewMode || !user) return;
    const isSelected = selectedUsers.some(
      (selected) => selected.id === user.id
    );
    if (isSelected) {
      setSelectedUsers(
        selectedUsers.filter((selected) => selected.id !== user.id)
      );
    } else {
      setSelectedUsers([...selectedUsers, user]);
    }
  };

  const handleSelectAll = () => {
    if (isViewMode) return;
    const allFilteredSelected = filteredUsers.every((user) =>
      selectedUsers.some((selected) => selected.id === user.id)
    );

    if (allFilteredSelected) {
      // Deselect all filtered users
      const newSelected = selectedUsers.filter(
        (selected) => !filteredUsers.some((user) => user.id === selected.id)
      );
      setSelectedUsers(newSelected);
    } else {
      // Select all filtered users
      const newSelected = [...selectedUsers];
      filteredUsers.forEach((user) => {
        if (!newSelected.some((selected) => selected.id === user.id)) {
          newSelected.push(user);
        }
      });
      setSelectedUsers(newSelected);
    }
  };

  const handleRemoveUser = (userId) => {
    if (isViewMode || !userId) return;
    setSelectedUsers(selectedUsers.filter((user) => user?.id !== userId));
  };

  const handleSubmit = async () => {
    if (!heading || !notification) {
      toast.error("Please fill in all required fields");
      return;
    }

    if (userType === "specific" && selectedUsers.length === 0) {
      toast.error("Please select at least one user");
      return;
    }

    const payload = {
      send_to: userType,
      title: heading,
      description: notification,
      user_ids: userType === "specific" ? selectedUsers.map((u) => u?.id) : [],
    };
    console.log("Notification Payload:", payload);

    try {
      let res = await post(URLS.PUSHNOTIFICATION, payload);
      if (res?.status === "success") {
        toast.success(res?.message || "Notification sent successfully");
        navigate("/notifications", { state: { page: page || 1 } });
      } else {
        toast.error(res?.message || "Failed to send notification");
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error(error?.message || "Failed to send notification");
    }
  };

  const handlePushNotification = async () => {
    try {
      let res = await get(URLS.USERLIST_DROPDOWN);
      if (res?.status === "success") {
        setUserList(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  useEffect(() => {
    handlePushNotification();
  }, []);

  console.log("handlePushNotification", userList);

  return (
    <>
      <PageHeader
        title={isViewMode ? "View Notification" : "Push Notifications"}
        showBackButton={true}
        onBackClick={() =>
          navigate("/notifications", { state: { page: page || 1 } })
        }
      />
      <div className="notification-add-container">
        <div className="notification-add-form">
          {/* User Type Selection */}
          <div
            className="user-type-section"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="radio-group">
              <label
                className={`radio-option ${
                  userType === "all" ? "active" : ""
                } ${isViewMode ? "disabled" : ""}`}
              >
                <input
                  type="radio"
                  name="userType"
                  value="all"
                  checked={userType === "all"}
                  onChange={(e) => setUserType(e.target.value)}
                  disabled={isViewMode}
                />
                <span className="radio-label">All Users</span>
              </label>
              <label
                className={`radio-option ${
                  userType === "specific" ? "active" : ""
                } ${isViewMode ? "disabled" : ""}`}
              >
                <input
                  type="radio"
                  name="userType"
                  value="specific"
                  checked={userType === "specific"}
                  onChange={(e) => setUserType(e.target.value)}
                  disabled={isViewMode}
                />
                <span className="radio-label">Specific Users</span>
              </label>
            </div>

            {/* Search User Dropdown - Only show when Specific Users is selected */}
          </div>
          {userType === "specific" && (
            <div className="search-user-section mb-3">
              {!isViewMode && <label>Search User</label>}
              {!isViewMode && (
                <div className="search-dropdown-wrapper" ref={dropdownRef}>
                  <input
                    type="text"
                    className="search-user-input"
                    placeholder="Search users..."
                    value={searchUser || ""}
                    onChange={(e) => {
                      setSearchUser(e.target.value);
                      setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                  />
                  {showDropdown && (
                    <div className="user-dropdown">
                      {(filteredUsers || []).length > 0 && (
                        <div
                          className="user-dropdown-item select-all-item"
                          onClick={handleSelectAll}
                          style={{
                            fontWeight: "bold",
                            borderBottom: "1px solid #eee",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Select All
                          {filteredUsers.every((user) =>
                            selectedUsers.some((s) => s.id === user.id)
                          ) ? (
                            <CheckCircleIcon
                              style={{ color: "green", marginRight: "10px" }}
                            />
                          ) : (
                            <RadioButtonUncheckedIcon
                              style={{ color: "gray", marginRight: "10px" }}
                            />
                          )}
                        </div>
                      )}
                      {(filteredUsers || []).length > 0 ? (
                        filteredUsers.map((user) => {
                          const isSelected = selectedUsers.some(
                            (s) => s.id === user.id
                          );
                          return (
                            <div
                              key={user?.id}
                              className="user-dropdown-item"
                              onClick={() => handleUserSelect(user)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              {user?.name || "Unknown"}
                              {isSelected ? (
                                <CheckCircleIcon
                                  style={{
                                    color: "green",
                                    marginRight: "10px",
                                  }}
                                />
                              ) : (
                                <RadioButtonUncheckedIcon
                                  style={{
                                    color: "gray",
                                    marginRight: "10px",
                                  }}
                                />
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <div className="user-dropdown-item">No users found</div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Selected Users List */}
              {(selectedUsers || []).length > 0 && (
                <div className="selected-users-list">
                  {selectedUsers.map((user) => (
                    <div key={user?.id} className="selected-user-item">
                      <span>{user?.name || "Unknown"}</span>
                      {!isViewMode && (
                        <FaTimes
                          className="remove-user-icon"
                          onClick={() => handleRemoveUser(user?.id)}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Heading */}
          <div className="form-group">
            <label>Heading</label>
            <input
              type="text"
              value={heading || ""}
              onChange={(e) => setHeading(e.target.value)}
              placeholder="Notification Heading!"
              disabled={isViewMode}
            />
          </div>

          {/* Notification */}
          <div className="form-group">
            <label>Notification</label>
            <textarea
              value={notification || ""}
              onChange={(e) => setNotification(e.target.value)}
              placeholder="Message!"
              rows={4}
              disabled={isViewMode}
            />
          </div>

          {/* Action Buttons */}
          {!isViewMode && (
            <div className="form-actions">
              <button
                type="button"
                className="btn-edit"
                onClick={() =>
                  navigate("/notifications", { state: { page: page || 1 } })
                }
              >
                Back
              </button>
              <button
                type="button"
                className="btn-submit"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationAdd;
